import { render, staticRenderFns } from "./DisposedAssetsReport.vue?vue&type=template&id=ddef1454"
import script from "./DisposedAssetsReport.vue?vue&type=script&lang=js"
export * from "./DisposedAssetsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports